const doc = [({"en":({"js":({"nemoa":({"activities":({"elections":({"election":({"election":"Election"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;